import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoggerService } from '../../core/logger.service';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import { User, ErrCode } from '../../shared/models';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'sync-oauth',
    templateUrl: './oauth.component.html'
})
export class OauthComponent implements OnInit, OnDestroy {

    private subscription: Subscription;
    private nonce: string;
    private redirect: string;
    private user: User;
    public error: ErrCode;

    constructor(
        private log: LoggerService,
        private store: Store<fromRoot.State>,
        private route: ActivatedRoute,
        private router: Router,
    ) { }


    async ngOnInit() {
        this.setUser();
        this.setNonce();
        this.setRedirect();

    }

    private setUser() {
        this.subscription = this.store
            .select(fromRoot.getAuthState)
            .subscribe((data) => {

                if (data && !data.authenticated && data.error) {
                    // No-OP a valid user doesn't exist therefore they have to sign in. Simple enough
                }
                if (data && data.authenticated) {
                    this.user = data.user;
                }
            });
    }

    private setNonce() {
        this.nonce = this.route.snapshot.queryParams['nonce'];
        if (!this.nonce) {
            this.error = new ErrCode(11101);
        }
    }

    private setRedirect() {
        this.log.info(`STATE PARMS: ${JSON.stringify(this.route.snapshot.queryParams)}`);
        this.redirect = this.route.snapshot.queryParams['redirect'];
        this.log.info(`User will be redirected to ${this.redirect}`);
        if (!this.redirect) {
            this.error = new ErrCode(11101);
        }
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    public signInNew() {
        this.router.navigate(['/login'], { queryParams: { return_to: '/oauth?nonce=' + this.nonce + '&redirect=' + this.redirect } });
    }

    public signInDifferent() {
        // Could directly return to the next OAuth step
        this.router.navigate(['/logout'], { queryParams: { return_to: '/oauth?nonce=' + this.nonce + '&redirect=' + this.redirect } });
    }

    public async signInCurrent() {
        if (!this.user.new_feature) {
            this.error = new ErrCode(11210);
        } else {
            this.router.navigate(['/oauthapp'], { queryParams: { nonce: this.nonce, redirect: this.redirect } });
        }
    }

}
